// extracted by mini-css-extract-plugin
export default {"list":"styles_list__cNGc1","list--linked":"styles_list--linked__c6uMg","list--unstyled":"styles_list--unstyled__r98TM"};